<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="28">mdi-android-studio</v-icon>
      </div>

      <span class="main-toolbar-title"> Template padrão de calibração </span>
    </div>
    <v-card flat class="mt-0">
      <TemplateTab />
    </v-card>
  </v-card>
</template>
<script>
import TemplateTab from './tab.vue'
export default {
  name: 'StandardTemplateCalibrationV2',

  components: {
    TemplateTab,
  },

  data() {
    return {
      tab: null,
    }
  },

  created() {
    console.log(this.$route.query)
    if (this.$route.query.tab != null)
      this.tab = parseInt(this.$route.query.tab)
  },
}
</script>
